import * as VideoPlayer from "../constants/videoPlayer";

const AWS_HOST = "https://player.live-video.net";
const AWS_VERSION = "1.5.1";
const VIDEO_JS_HOST = "https://cdnjs.cloudflare.com/ajax/libs/video.js";
const VIDEO_JS_VERSION = "7.18.0";

export const config = {
  AWS_IVS_SCRIPT_URL: `${AWS_HOST}/${AWS_VERSION}/amazon-ivs-player.min.js`,
  AWS_IVS_TECH_SCRIPT_URL: `${AWS_HOST}/${AWS_VERSION}/amazon-ivs-videojs-tech.min.js`,
  AWS_QUALITY_PLUGIN_SCRIPT_URL: `${AWS_HOST}/${AWS_VERSION}/amazon-ivs-quality-plugin.min.js`,
  VIDEOJS_SCRIPT_URL: `${VIDEO_JS_HOST}/${VIDEO_JS_VERSION}/video.min.js`,
  VIDEOJS_STYLE_URL: `${VIDEO_JS_HOST}/${VIDEO_JS_VERSION}/video-js.css`,
  MIN_LIVE_SESSION_TITLE_LENGTH: 5,
  MAX_LIVE_SESSION_TITLE_LENGTH: 50,
  MIN_LIVE_SESSION_DESCRIPTION_LENGTH: 50,
  MAX_LIVE_SESSION_DESCRIPTION_LENGTH: 500,
  MIN_DAYS_SCHEDULE_LIVE_SESSION: 1,
  MAX_DAYS_SCHEDULE_LIVE_SESSION: 7,
  MIN_LIVE_CHAT_MESSAGE_LENGTH: 1,
  MAX_LIVE_CHAT_MESSAGE_LENGTH: 500,
  MIN_BITRATE_QUALITY: 230000,
  AWS_STREAM_DISPLAY_ERROR_CODES: ["ErrorNotAvailable"],
  DEFAULT_VIDEO_PLAYER: VideoPlayer.VIDEO_JS,
  SESSION_FINISHED_REDIRECT_TIMEOUT: 15000,
  READY_TO_LIVE_ALERT_HOURS_NOTICE: 2,
  DEFAULT_DOMESTIKA_STREAMER_NAME: "Domestika",
  DEFAULT_DOMESTIKA_STREAMER_AVATAR:
    "ar_1:1,c_fill,dpr_1.0,f_auto,h_72,pg_1,t_base_params,w_72/v1593423483/avatars/000/000/002/2-original.png?1593423483",
};
